export var CombinedFeaturesEnum;
(function (CombinedFeaturesEnum) {
    CombinedFeaturesEnum["energy"] = "energySource";
    CombinedFeaturesEnum["constructionYear"] = "yearOfConstruction";
    CombinedFeaturesEnum["heating"] = "heatingSystem";
    CombinedFeaturesEnum["state"] = "state";
    CombinedFeaturesEnum["houseType"] = "houseType";
    CombinedFeaturesEnum["basedOn"] = "basedOn";
    CombinedFeaturesEnum["validity"] = "validity";
    CombinedFeaturesEnum["yearOfConstructionBuilding"] = "yearOfConstructionBuilding";
    CombinedFeaturesEnum["yearOfConstructionHeating"] = "yearOfConstructionHeating";
    CombinedFeaturesEnum["primaryEnergySource"] = "primaryEnergySource";
    CombinedFeaturesEnum["minergieStandard"] = "minergieStandard";
    CombinedFeaturesEnum["nameOfCertificate"] = "nameOfCertificate";
    CombinedFeaturesEnum["excessiveConsumption"] = "excessiveConsumption";
    CombinedFeaturesEnum["lastModernisation"] = "lastModernisation";
})(CombinedFeaturesEnum || (CombinedFeaturesEnum = {}));
export var ScaleEnum;
(function (ScaleEnum) {
    ScaleEnum["DE_COMMERCIAL"] = "DE_COMMERCIAL";
    ScaleEnum["DE_RESIDENTIAL"] = "DE_RESIDENTIAL";
    ScaleEnum["AT"] = "AT";
    ScaleEnum["FR_GHG_BEFORE_2021"] = "FR_GHG_BEFORE_2021";
    ScaleEnum["FR_ENERGY_AFTER_2021"] = "FR_ENERGY_AFTER_2021";
    ScaleEnum["FR_ENERGY_BEFORE_2021"] = "FR_ENERGY_BEFORE_2021";
    ScaleEnum["FR_GHG_AFTER_2021"] = "FR_GHG_AFTER_2021";
})(ScaleEnum || (ScaleEnum = {}));
